import React from 'react'

interface IAvatarCircle {
    name: string
    size?: number
}

const AvatarCircle = ({ name, size }: IAvatarCircle) => {
    const getInitials = (name: string): string => {
        const words = name.split(' ')
        const letter = words
            .map((word) => word[0])
            .join('')
            .toUpperCase()
        return letter
            .split('')
            .map((val, index) => {
                if (index < 2) return val
                return ''
            })
            .join('')
    }

    const initials = getInitials(name)
    const circleSize = !size ? 'w-8 h-8' : ''

    return (
        <div
            className={`flex items-center justify-center themes-avatar rounded-full ${circleSize}`}
            style={{ height: size, width: size }}
        >
            <span className="text-size-S font-semibold ml-[0.9px] mt-1">
                {initials}
            </span>
        </div>
    )
}

export default AvatarCircle
